import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../../../context/AuthContext';
import logo from '../../../assets/components/logo-white.png'

const Sidebar = () => {

  const { logout } = useAuth();
  const navigate = useNavigate();

	return (
		<>
			<div className="w-[15%] bg-black">
				<div className="px-5 py-10">
					<img src={logo} alt="" className="w-[60%]" />
				</div>
				<ul className="text-white">
					<NavLink to="/admin/home">
						<li className="uppercase text-md px-5 py-4 border-t-[0.5px] hover:bg-gray-900" style={{fontFamily: "Muli"}}>
							home
						</li>
					</NavLink>
					<NavLink to="/admin/create">
						<li className="uppercase text-md px-5 py-4 border-t-[0.5px] hover:bg-gray-900" style={{fontFamily: "Muli"}}>
							create a blog post
						</li>
					</NavLink>
					<NavLink to="/admin/blog">
						<li className="uppercase text-md px-5 py-4 border-t-[0.5px] hover:bg-gray-900" style={{fontFamily: "Muli"}}>
							blogs
						</li>
					</NavLink>
					<NavLink to='/admin/upload-to-portfolio'>
						<li className="uppercase text-md px-5 py-4 border-t-[0.5px] hover:bg-gray-900" style={{fontFamily: "Muli"}}>
							upload image to portolios
						</li>
					</NavLink>
					<NavLink to='/admin/upload-to-subportfolio'>
						<li className="uppercase text-md px-5 py-4 border-t-[0.5px] hover:bg-gray-900" style={{fontFamily: "Muli"}}>
							upload image to sub portolios
						</li>
					</NavLink>
					<NavLink to="/admin/portfolio">
						<li className="uppercase text-md px-5 py-4 border-t-[0.5px] hover:bg-gray-900" style={{fontFamily: "Muli"}}>
							portfolio
						</li>
					</NavLink>
					<NavLink to="/admin/sub-portfolio/">
						<li className="uppercase text-md px-5 py-4 border-t-[0.5px] hover:bg-gray-900" style={{fontFamily: "Muli"}}>
							sub-portfolio
						</li>
					</NavLink>
					<NavLink to="/admin/contact">
						<li className="uppercase text-md px-5 py-4 border-t-[0.5px] hover:bg-gray-900" style={{fontFamily: "Muli"}}>
							contact form
						</li>
					</NavLink>
					<NavLink to="/admin/bookings">
						<li className="uppercase text-md px-5 py-4 border-t-[0.5px] hover:bg-gray-900" style={{fontFamily: "Muli"}}>
							bookings
						</li>
					</NavLink>
					<NavLink to="/admin/academy">
						<li className="uppercase text-md px-5 py-4 border-t-[0.5px] hover:bg-gray-900" style={{fontFamily: "Muli"}}>
							academy form
						</li>
					</NavLink>
					<NavLink to="/admin/tcq-applications">
						<li className="uppercase text-md px-5 py-4 border-t-[0.5px] hover:bg-gray-900" style={{fontFamily: "Muli"}}>
							TCQ applications
						</li>
					</NavLink>
					<NavLink to="/admin/subscribers">
						<li className="uppercase text-md px-5 py-4 border-t-[0.5px] hover:bg-gray-900" style={{fontFamily: "Muli"}}>
							subscribers
						</li>
					</NavLink>
					<div
				      onClick={() => {
				        logout();
				        navigate('/admin/login');
				      }}
				      className="cursor-pointer uppercase text-md px-5 py-4 border-t-[0.5px] hover:bg-gray-900"
				      style={{ fontFamily: 'Muli' }}
				    >
				      logout
				    </div>



				</ul>
			</div>
		</>
	)
}

export default Sidebar